module.exports = __webpack_public_path__ + "img/C24.fa90c44a.png";